import * as yup from 'yup';

import localization from 'localization';

const getRequiredMessage = () => {
  const i18n = localization.cloneInstance();

  return i18n.t('shared.validation.field.required');
};

const getMinLengthError = () => {
  const i18n = localization.cloneInstance();

  return i18n.t('Full name must be at least 2 characters');
};

export default yup
  .string()
  .required(getRequiredMessage)
  .min(2, getMinLengthError)
  .trim()
  .nullable();
